/**
 * Finds errors in the submitted fields, either unacceptable fields,
 * like a letter choice Z, or missing required fields.
 * @param {object} data parsed data object from CSV upload
 * @returns {object} {fieldWarnings, fieldErrors} 
 */
export default function verifyFields (data) {
  const fieldWarnings = []
  const fieldErrors = []

  // subject names and item counts
  const subjects = [
    {name: 'English', count: 75}, 
    {name: 'Math', count: 60}, 
    {name: 'Reading', count: 40}, 
    {name: 'Science', count: 40}
  ]

  function findOddFieldErrors(data) {
    // These are the only allowed responses for student response fields
    // that are numbered odd.
    const allowed = {
      A: true,
      B: true,
      C: true,
      D: true,
      E: true,
      BLANK: true,
      '': true,
    }

    const errors = []
    // The keys in data are in the format Math1, Math2, English 15
    // etc. so iterate over the odd ones and see if they have acceptable
    // responses.
    data.forEach(student => {
      subjects.forEach(({name, count}) => {
        for (let i = 1; i <= count; i++) {
          const responseToCheck = student[`${name}${i}`]
          const oddQ = (i % 2 === 1)
          if (!allowed[responseToCheck] && oddQ) {
            const error = {
              error: `Invalid response to field ${name}${i}: ${responseToCheck}`,
              rows: [student.row],
            }
            errors.push(error)
          }
        }
      })
    })
    return errors
  }

  function findEvenFieldErrors(data) {
    // These are the only allowed responses for student response fields
    // that are numbered even.
    const allowed = {
      F: true,
      G: true,
      H: true,
      J: true,
      K: true,
      BLANK: true,
      '': true,
    }
    let errors = []
    // The keys in data are in the format Math1, Math2, English 15
    // etc. so iterate over the even ones and see if they have acceptable
    // responses.
    data.forEach(student => {
      subjects.forEach(({name, count}) => {
        for (let i = 1; i <= count; i++) {
          const responseToCheck = student[`${name}${i}`]
          const evenQ = i % 2 === 0
          if (!allowed[responseToCheck] && evenQ) {
            const error = {
              error: `Invalid response to field ${name}${i}: ${responseToCheck}`,
              rows: [student.row],
            }
            errors.push(error)
          }
        }
      })
    })
    return errors
  }

  // If first name or last name is missing, flags the error.
  function findEmptyRequiredFields(data) {
    let errors = []
    data.forEach(student => {
      if (!student.First) {
        const error = {
          error: `First name missing.`,
          rows: [student.row]
        }
        errors.push(error)
      } else if (!student.Last) {
        const error = {
          error: `Last name missing.`,
          rows: [student.row]
        }
        errors.push(error)
      }
    })
    return errors
  }

  // find the invalid responses and empty required fields
  const oddErrors = findOddFieldErrors(data)
  const evenErrors = findEvenFieldErrors(data)
  const emptyRequiredFields = findEmptyRequiredFields(data)

  // add the found errors to the output arrays
  oddErrors.forEach(err => fieldErrors.push(err))
  evenErrors.forEach(err => fieldErrors.push(err))
  emptyRequiredFields.forEach(err => fieldErrors.push(err))

  return { fieldWarnings, fieldErrors }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/verifyFields.js